
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bounties/[id]",
      function () {
        return require("private-next-pages/bounties/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bounties/[id]"])
      });
    }
  